<template>
<div class="chapter">
<div class="inner_page">
<h2 class="calibre" id="pgepubid00012">CHAPTER I</h2>
<h3 class="calibre8 sigil_not_in_toc" id="pgepubid00013">TO THE FRONT</h3>
<p class="calibre3">"I know it's utterly foolish and unreasonable," sighed Amy Blackford,
laying down the novel she had been reading and looking wistfully out of
the window, "but I simply can't help it."</p>
<p class="calibre3">"What's the matter?" asked Mollie Billette, raising her eyes reluctantly
from a book she was devouring and looking vaguely at Amy's profile. "Did
you say something?"</p>
<p class="calibre3">"No, she only spoke," drawled Grace Ford, extricating herself from a
mass of bright-colored cushions on the divan, preparatory to joining in
the conversation. "I ask you, Mollie, did you ever know Amy to say
anything important?"</p>
<p class="calibre3">"Why yes, I have," said Mollie unexpectedly. "In fact, she is about the
only one of us Outdoor Girls who ever does say anything
important—except Betty, perhaps."<span id="pgepubid00014" title="[2]"><a id="Page_2" title="[2]"></a></span></p>
<p class="calibre3">Amy withdrew her gaze from the landscape and looked at the speaker with
a twinkle in her eyes.</p>
<p class="calibre3">"What will you have, Mollie?" she asked whimsically. "When you become
complimentary, you are apt to rouse my suspicions."</p>
<p class="calibre3">"Well, whatever you were going to say, please say it, and let me get
back to my book," returned Mollie, ignoring the imputation. "I was in
the most interesting part—"</p>
<p class="calibre3">"Why, I'm just plain homesick," said Amy, adding quickly, as the girls
looked at her in surprise. "For Camp Liberty and the Hostess House, you
know. I miss the work and the long hours of entertaining and cheering
people up. I feel," she looked around at them as though finding it hard
to explain just what she meant, "sort of—lost."</p>
<p class="calibre3">The three chums, Mollie Billette, Grace Ford, and Amy Blackford were
gathered in the comfortable library of Betty Nelson's home—Betty being
the fourth of the merry quartette, dubbed the "Outdoor Girls" by the
people of Deepdale, because of their love of the open and of outdoor
sports.</p>
<p class="calibre3">The girls, as my old readers will doubtless remember, had helped
establish a Hostess House at Camp Liberty, and since then had given all
their<span id="pgepubid00015" title="[3]"><a id="Page_3" title="[3]"></a></span> strength and time and youthful enthusiasm to the great work of
cheering our young fighters, entertaining their loved ones, and, in the
end, sending them with fresh courage and happy memories to the "other
side" for the great adventure.</p>
<p class="calibre3">And now the girls, completely worn out in their loving service to
others, had been sent, much against their will, home to Deepdale for a
rest that they sorely needed.</p>
<p class="calibre3">To-day they had gathered in Betty's house to discuss the rather hazy
plans for their brief vacation. And Amy had simply voiced what was in
the thoughts of all the girls. They were, undeniably and heartily,
homesick for Camp Liberty and their work at the Hostess House.</p>
<p class="calibre3">"Lost?" Mollie repeated Amy's expression thoughtfully. "Yes, I guess
that would pretty well describe the feeling I've had for the last few
days. Sort of restless and aimless—wondering what to do next."</p>
<p class="calibre3">"Goodness!" cried Grace whimsically, stretching her arms above her head
and smothering a yawn, "this is terrible, you know. If we don't look
out, we'll be forgetting how to enjoy ourselves."</p>
<p class="calibre3">"That would be queer, wouldn't it?" agreed Mollie, with a chuckle as she
started to resume her reading. "Especially for the Outdoor Girls,<span id="pgepubid00016" title="[4]"><a id="Page_4" title="[4]"></a></span> who
used to know how to enjoy themselves remarkably well."</p>
<p class="calibre3">A brief silence followed, broken only by the rustle of paper as one of
the girls turned a page. Then, so suddenly that Mollie jumped nervously
and Grace almost upset a box of chocolates at her elbow, Amy threw down
her book and sprang to her feet.</p>
<p class="calibre3">"I can't stand it another minute!" she exclaimed desperately. "Girls, I
must get out and do something—this loafing is getting on my nerves."</p>
<p class="calibre3">"Goodness, the child's mad," declared Mollie, looking at her chum with a
mixture of amusement and sympathy in her eyes. "What do you want to do,
Amy, start a fight, or set the town on fire? Whatever it is, I'm for
you, as Roy would say."</p>
<p class="calibre3">"Oh, I guess I must be crazy," said Amy, subsiding and seeming a little
ashamed of her outburst. "Only, after so much band music and parades and
bugle calls—everything in Deepdale seems so quiet."</p>
<p class="calibre3">"Well, if all you want is noise, we'll easily fix that," said Mollie
briskly, running to the piano and gathering in Grace and Amy on the way.
"Sing," she commanded, "and I'll make as much noise as I can on the
piano."<span id="pgepubid00017" title="[5]"><a id="Page_5" title="[5]"></a></span></p>
<p class="calibre3">Half laughing, half protesting, the girls obeyed while Mollie
conscientiously made good her threat with the piano, and it was into
this uproar that Betty Nelson stepped a moment later.</p>
<p class="calibre3">"Have mercy!" she screamed above the noise, both hands clapped over her
ears while she laughed at them. "I thought they had turned the house
into a lunatic asylum or something."</p>
<p class="calibre3">The music, if such it can be called, stopped so suddenly that Betty's
last words rang out with absurd distinctness.</p>
<p class="calibre3">"Or something," Mollie mimicked, whirling around and catching the
newcomer in a bear's embrace. "Come over to the couch, Betty Nelson, and
explain yourself. Where have you been and why did you keep us waiting?"</p>
<p class="calibre3"><ins class="calibre19" title="Transcriber's Note: original reads 'Laugingly'">Laughingly</ins> the Little Captain, as she was often called by the girls
because of her talent for leadership, permitted herself to be dragged
over to the couch by the impulsive Mollie, while Amy and Grace seated
themselves on the arms.</p>
<p class="calibre3">"What would you?" protested Betty, looking from one accusing face to
another. "I said I would meet you here at two-thirty, and it is only
quarter past now."</p>
<p class="calibre3">"Only quarter past!" exclaimed Amy.</p>
<p class="calibre3">"Oh, is that all?" asked Mollie, in astonishment, adding, as Betty
lifted her wrist watch for<span id="pgepubid00018" title="[6]"><a id="Page_6" title="[6]"></a></span> inspection: "Goodness, I thought we had been
waiting ages."</p>
<p class="calibre3">"I'm glad you wanted to see me so much," chuckled the Little Captain,
adding, with a mischievous twinkle in her eyes: "I imagine you would
have been still more impatient if you had known—" she paused wickedly
and just looked at them.</p>
<p class="calibre3">"Don't tease, Betty! What is it?" they implored in chorus, fairly
pouncing upon her, while Grace added, eagerly:</p>
<p class="calibre3">"Is it possible you have anything really interesting to tell us?"</p>
<p class="calibre3">"I shouldn't wonder if you would think so," Betty teased, adding quickly
to forestall the outburst she saw was coming, "It really isn't anything
at all—only—I met the postman on my way—"</p>
<p class="calibre3">"Betty!" they cried, unable to contain their impatience another moment.
"You have letters! Letters from our soldier boys!"</p>
<p class="calibre3">"How did you guess it?" said Betty, her eyes dancing as she brought from
a convenient pocket three—yes, three—fat letters, each containing the
longed-for foreign postmark.</p>
<p class="calibre3">"How much will you give me?" teased Betty, holding the precious missives
behind her back.</p>
<p class="calibre3">"Not one other word, Betty Nelson!" they<span id="pgepubid00019" title="[7]"><a id="Page_7" title="[7]"></a></span> cried, and after a merry but
brief struggle the letters were seized and delivered to their rightful
owners.</p>
<p class="calibre3">"Now I wonder," drawled Grace with a twinkle, as she hastily tore open
her envelope, "who could possibly be writing to us from the other side?"</p>
<p class="calibre3">"Now I wonder," chuckled Betty, as she happily drew from the convenient
pocket the last, but in her estimation decidedly not the least, fat
letter and proceeded to devour its contents without delay.</p>
<p class="calibre3">And indeed the Outdoor Girls had little reason to wonder who their
correspondents might be, for as regularly as clockwork those precious
letters with the strange foreign postmarks were delivered to their eager
hands.</p>
<p class="calibre3">There were other letters with that foreign postmark, too, for in
addition to their work at the Hostess House, the girls had faithfully
kept up a large correspondence with the brave boys who had already
crossed the water and were waiting impatiently for their chance "at the
Huns."</p>
<p class="calibre3">But the four special letters were from their closest friends—boys who
had lived in Deepdale before the war and were now in France preparing
for the last stage of their journey.</p>
<p class="calibre3">Allen Washburn, on his way to make a great name for himself in the law
before the war put a<span id="pgepubid00020" title="[8]"><a id="Page_8" title="[8]"></a></span> temporary check upon his ambitions, had been in
love with the Little Captain for—oh, yes, ever since he could remember,
while Betty—but Betty would never really admit anything, not even to
herself.</p>
<p class="calibre3">Then there was Will Ford, Grace Ford's brother, who was not only devoted
to his pretty sister, but, in spite of Amy's flushed protestations to
the contrary, to Amy Blackford, also—although in quite a different
manner!</p>
<p class="calibre3">Frank Haley was a high school chum of Will's, who from the time of his
first meeting with Mollie Billette had seemed inclined to become her
shadow, to the latter's secret gratification and outward indifference.</p>
<p class="calibre3">The last of the quartette was Roy Anderson, one of the Deepdale boys,
who was chiefly distinguished by his very open admiration for Grace.</p>
<p class="calibre3">The boys had shared in many of the adventures of the Outdoor Girls, and
of course had been among the very first to volunteer to help "lick the
Boche" as they slangily but ardently put it. The girls had gloried in
their patriotism, and it was their assignment to Camp Liberty that had
first given Betty the idea of working in the Hostess House there.</p>
<p class="calibre3">They had been very happy, fired as they were by enthusiastic patriotism,
until the fateful day<span id="pgepubid00021" title="[9]"><a id="Page_9" title="[9]"></a></span> had come when the boys had entrained for
Philadelphia and from there to the Great Adventure. Then for the first
time the girls had had the real and terrible meaning of war brought home
to them. And the boys, so merry and care-free when they had first
entered the service, had seemed suddenly older, more important, more
manly, only the fire of enthusiasm in their eyes showing their
indomitable youth.</p>
<p class="calibre3">Several months had passed since that day of mingled tears and pride and
heartache, and the girls had had time to get used to the separation a
little—a very little. And now Betty had brought them the letters they
were always hungry for, anxiously eager, yet always, at the very back of
their hearts, a little haunting fear of what they might contain.</p>
<p class="calibre3">For several minutes they sat engrossed while occasionally one of them
read a funny or characteristic extract over which they laughed happily.</p>
<p class="calibre3">"Listen to this," chuckled Mollie, while the girls looked up
expectantly. "Frank says that Roy is getting terribly fat in spite of
all the exercise—"</p>
<p class="calibre3">"Horrors!" interjected Grace.</p>
<p class="calibre3">"And when he, Frank, ventured to remonstrate with him the other day and
advised him to cut<span id="pgepubid00022" title="[10]"><a id="Page_10" title="[10]"></a></span> down on his chow, Roy said: 'Nothing doing! I've got
a definite end in view, old man. This khaki outfit has acquired so much
terra firma it's beginning to stand alone, but if I get so fat I can't
wear it they'll have to give me another one—see?'"</p>
<p class="calibre3">The girls laughed, but there was just a shade of wistfulness in their
laughter, for they knew that the boys were only skirting the outer edge
of the hardships they would be called upon to encounter later on.</p>
<p class="calibre3">Then suddenly Betty gave a little cry of dismay.</p>
<p class="calibre3">"Oh, girls," she cried when they looked up at her fearfully, "it's come!
What we've been dreading so long! The boys have been ordered to the
front!"<span id="pgepubid00023" title="[11]"><a id="Page_11" title="[11]"></a></span></p>
<div class="pg-boilerplate" id="calibre_pb_10"></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0003.vue?0fc9abdb